export default "__VITE_ASSET__De_vDgf0__"